export const UI = {
  it: {
    ctaHeader: 'Richiedi una consulenza',
    menuOpen: 'Apri menu',
    menuClose: 'Chiudi menu',
    tocTitle: 'In questa pagina',
    metaReviewed: 'Ultima revisione',
    metaReading: 'Lettura',
    faqTitle: 'Domande frequenti',
    relatedTitle: 'Continua a leggere',
    readGuide: 'Leggi la guida',
    checklistProgress: '{n} di {m} completati',
    caseSituation: 'La situazione',
    caseProblem: 'Il problema',
    caseRisks: 'I rischi individuati',
    caseDecisions: 'Le decisioni prese',
    caseResult: 'Il risultato',
    explore: 'Esplora',
    exploreArea: 'Esplora l\u2019area',
    breadcrumbHome: 'Home',
    footerTagline: 'Broker assicurativo in Svizzera. Wealth & Risk Consulting è il nostro approccio a patrimonio, previdenza, rischi e coperture — anche in caso di sinistro.',
    footerClaims: 'Hai avuto un sinistro?',
    footerColSoluzioni: 'Soluzioni',
    footerColGuide: 'Guide',
    footerColAgenzia: 'Agenzia',
    footerQuickTitle: 'Contatto rapido',
    footerRights: 'Tutti i diritti riservati.',
    footerCookiePrefs: 'Preferenze cookie',
    cookieTitle: 'Preferenze cookie',
    cookieText: 'Usiamo una tecnologia necessaria per ricordare la tua scelta e, solo se lo autorizzi, Google Analytics 4 per misurare in forma statistica l\u2019utilizzo del sito.',
    cookiePolicyLink: 'Leggi la Cookie Policy',
    cookieReject: 'Solo necessari',
    cookieAccept: 'Accetta analitici',
    cookieCustomize: 'Personalizza',
    cookieSave: 'Salva preferenze',
    cookieBack: 'Indietro',
    cookieAlwaysOn: 'Sempre attivi',
    cookieNecessaryTitle: 'Necessari',
    cookieNecessaryText: 'Servono a ricordare la scelta sui cookie e a mantenere il sito disponibile. Non possono essere disattivati dal banner.',
    cookieAnalyticsTitle: 'Analitici',
    cookieAnalyticsText: 'Google Analytics 4 viene caricato solo dopo il consenso. I segnali pubblicitari e la personalizzazione degli annunci restano disattivati.',
    cookieConsentNote: 'Puoi cambiare scelta in qualsiasi momento dal link \"Preferenze cookie\" nel footer.',
    formNome: 'Nome',
    formCognome: 'Cognome',
    formEmail: 'Email',
    formTelefono: 'Telefono',
    formMessaggio: 'Messaggio',
    formMessaggioPh: 'Raccontaci brevemente la tua situazione…',
    formPrivacy: 'Ho letto l\u2019informativa privacy e autorizzo l\u2019uso dei dati indicati per gestire la mia richiesta e ricontattarmi. *',
    formPrivacyClaim: 'Ho letto l\u2019informativa privacy e, se inserisco dati sensibili (ad es. sulla salute), acconsento espressamente al loro trattamento per gestire la segnalazione. *',
    formInvia: 'Invia richiesta',
    formInviaMsg: 'Invia messaggio',
    quickNomePh: 'Nome e cognome *',
    quickContattoPh: 'Email o telefono *',
    quickMsgPh: 'Come possiamo aiutarti? *',
    quickSuccess: 'Messaggio inviato. Ti ricontatteremo presto.',
    successTitle: 'Richiesta inviata',
    successText: 'Grazie! Ti ricontatteremo al più presto per approfondire la tua situazione.',
    tipoQuestion: 'Sei un privato o un\u2019azienda? *',
    tipoPrivato: 'Privato',
    tipoAzienda: 'Azienda',
    argomentoLabel: 'Argomento *',
    orarioLabel: 'Fascia oraria preferita',
    selectDefault: 'Seleziona…',
    noPreference: 'Nessuna preferenza',
    topics: ['Nuova consulenza', 'Verifica contratti esistenti', 'Cassa malati', 'Previdenza', 'Azienda', 'Sinistro', 'Collaborazione', 'Altro'],
    timeSlots: ['Mattina (8:30–12:00)', 'Primo pomeriggio (13:30–16:00)', 'Tardo pomeriggio (16:00–18:00)'],
    claimNome: 'Nome e cognome *',
    claimAzienda: 'Azienda (se applicabile)',
    claimData: 'Data del sinistro *',
    claimLuogo: 'Luogo',
    claimPolizza: 'Numero di polizza (se noto)',
    claimUrgenza: 'Urgenza *',
    claimDescrizione: 'Descrizione del sinistro *',
    claimDescrizionePh: 'Cosa è successo? Chi è coinvolto? Quali danni vedi?',
    claimDocs: 'Documenti e fotografie',
    claimDocsHint: 'Foto del danno, verbali, documenti utili. Puoi anche inviarli in seguito.',
    claimSubmit: 'Invia segnalazione di sinistro',
    claimTypeHint: 'Seleziona prima il tipo di sinistro qui sopra.',
    claimSuccessTitle: 'Segnalazione ricevuta',
    claimSuccessText: 'Abbiamo registrato la tua segnalazione. Ti ricontatteremo al più presto per i prossimi passaggi e per indicarti eventuali documenti mancanti.',
    urgencyOptions: ['Urgente — danno in corso o persone coinvolte', 'Importante — serve una valutazione a breve', 'Standard — segnalazione senza urgenza particolare'],
    notFoundTitle: 'Pagina non trovata',
    notFoundText: 'Il contenuto che cerchi non esiste o è stato spostato. Torna alla home o esplora le soluzioni.',
    notFoundButton: 'Torna alla home',
    highlights: 'In evidenza',
    allGuides: 'Tutte le guide',
  },
  en: {
    ctaHeader: 'Request a consultation',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    tocTitle: 'On this page',
    metaReviewed: 'Last reviewed',
    metaReading: 'Reading time',
    faqTitle: 'Frequently asked questions',
    relatedTitle: 'Keep reading',
    readGuide: 'Read the guide',
    checklistProgress: '{n} of {m} completed',
    caseSituation: 'The situation',
    caseProblem: 'The problem',
    caseRisks: 'The risks identified',
    caseDecisions: 'The decisions taken',
    caseResult: 'The outcome',
    explore: 'Explore',
    exploreArea: 'Explore this area',
    breadcrumbHome: 'Home',
    footerTagline: 'Insurance broker in Switzerland. Wealth & Risk Consulting is our approach to assets, pensions, risks and cover — including claims support.',
    footerClaims: 'Had a claim?',
    footerColSoluzioni: 'Solutions',
    footerColGuide: 'Guides',
    footerColAgenzia: 'Agency',
    footerQuickTitle: 'Quick contact',
    footerRights: 'All rights reserved.',
    footerCookiePrefs: 'Cookie preferences',
    cookieTitle: 'Cookie preferences',
    cookieText: 'We use a necessary technology to remember your choice and, only if you allow it, Google Analytics 4 to statistically measure how the website is used.',
    cookiePolicyLink: 'Read the Cookie Policy',
    cookieReject: 'Necessary only',
    cookieAccept: 'Accept analytics',
    cookieCustomize: 'Customise',
    cookieSave: 'Save preferences',
    cookieBack: 'Back',
    cookieAlwaysOn: 'Always on',
    cookieNecessaryTitle: 'Necessary',
    cookieNecessaryText: 'These are used to remember your cookie choice and keep the website available. They cannot be disabled from this banner.',
    cookieAnalyticsTitle: 'Analytics',
    cookieAnalyticsText: 'Google Analytics 4 is loaded only after consent. Advertising signals and ad personalisation remain disabled.',
    cookieConsentNote: 'You can change your choice at any time from the \"Cookie preferences\" link in the footer.',
    formNome: 'First name',
    formCognome: 'Last name',
    formEmail: 'Email',
    formTelefono: 'Phone',
    formMessaggio: 'Message',
    formMessaggioPh: 'Briefly tell us about your situation…',
    formPrivacy: 'I have read the privacy policy and authorise use of the data provided to handle my request and contact me. *',
    formPrivacyClaim: 'I have read the privacy policy and, if I provide sensitive data (e.g. health data), I explicitly consent to its processing to handle the report. *',
    formInvia: 'Send request',
    formInviaMsg: 'Send message',
    quickNomePh: 'Full name *',
    quickContattoPh: 'Email or phone *',
    quickMsgPh: 'How can we help? *',
    quickSuccess: 'Message sent. We will get back to you soon.',
    successTitle: 'Request sent',
    successText: 'Thank you! We will contact you shortly to discuss your situation.',
    tipoQuestion: 'Are you an individual or a business? *',
    tipoPrivato: 'Individual',
    tipoAzienda: 'Business',
    argomentoLabel: 'Topic *',
    orarioLabel: 'Preferred time slot',
    selectDefault: 'Select…',
    noPreference: 'No preference',
    topics: ['New consultation', 'Review of existing contracts', 'Health insurance', 'Pension planning', 'Business', 'Claim', 'Partnership', 'Other'],
    timeSlots: ['Morning (8:30–12:00)', 'Early afternoon (1:30–4:00 pm)', 'Late afternoon (4:00–6:00 pm)'],
    claimNome: 'Full name *',
    claimAzienda: 'Company (if applicable)',
    claimData: 'Date of the claim *',
    claimLuogo: 'Location',
    claimPolizza: 'Policy number (if known)',
    claimUrgenza: 'Urgency *',
    claimDescrizione: 'Description of the claim *',
    claimDescrizionePh: 'What happened? Who is involved? What damage can you see?',
    claimDocs: 'Documents and photos',
    claimDocsHint: 'Photos of the damage, reports, useful documents. You can also send them later.',
    claimSubmit: 'Submit claim report',
    claimTypeHint: 'Please select the claim type above first.',
    claimSuccessTitle: 'Report received',
    claimSuccessText: 'We have registered your report. We will contact you shortly with the next steps and any missing documents.',
    urgencyOptions: ['Urgent — ongoing damage or people involved', 'Important — assessment needed soon', 'Standard — no particular urgency'],
    notFoundTitle: 'Page not found',
    notFoundText: 'The content you are looking for does not exist or has been moved. Go back home or explore our solutions.',
    notFoundButton: 'Back to home',
    highlights: 'Highlights',
    allGuides: 'All guides',
  },
};
